import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.css";

export default function NotFoundPage() {
  return (
    <div className={styles.container}>
      <p className={styles.code}>404</p>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.message}>The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className={styles.homeLink}>
        Back to home
      </Link>
    </div>
  );
}
